module.exports = __webpack_public_path__ + "static/img/mobile-高频活跃.b13493a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-高频活跃.png
// module id = yW6r
// module chunks = 0